const getters = {
  hasPermission: (state) => (permissionKey) => {
    return !!state.permissions[permissionKey];
  },
};

export default getters;
